module.exports = __webpack_public_path__ + "static/img/11.65d914d5.jpg";